module.exports = {"TXTWCL_You_Won_N0X":{"id":"TXTWCL_You_Won_N0X","defaultMessage":"Sie haben {0} gewonnen!"}}